export const PLATFORM_IDS = ['wix', 'etsy', 'ebay', 'amazon', 'shopify', 'woocommerce'] as const;
export type PlatformId = (typeof PLATFORM_IDS)[number];

/**
 * Universal product shape the Studio core sees, regardless of source platform.
 */
export interface UniversalProduct {
  /** Global identifier: `${platformId}:${platformProductId}`. */
  uid: string;
  platformId: PlatformId;
  platformProductId: string;
  title: string;
  sku: string | null;
  status: 'active' | 'draft' | 'archived';
  url: string | null;
  primaryImageUrl: string | null;
  imageCount: number;
  variantCount: number;
  /** ISO 8601 timestamp. */
  lastSyncedAt: string;
}

/**
 * Universal media shape — one image attached to one platform product.
 */
export interface UniversalMedia {
  /** `${platformId}:${platformProductId}:${platformMediaId}`. */
  uid: string;
  platformId: PlatformId;
  platformProductId: string;
  platformMediaId: string;
  url: string;
  width: number | null;
  height: number | null;
  position: number;
  isPrimary: boolean;
  altText: string | null;
}

/**
 * Draft image — generated locally, not yet attached to a platform product.
 */
export interface DraftMedia {
  id: string;
  workspaceId: string;
  productUid: string | null;
  /** Signed URL on GCS. */
  url: string;
  width: number;
  height: number;
  /** ISO 8601. */
  createdAt: string;
}

export type GalleryImageKind = 'live' | 'draft' | 'sales';

export type GalleryImage =
  | (UniversalMedia & { kind: 'live' | 'sales'; productTitle: string | null })
  | (DraftMedia & { kind: 'draft'; productTitle: string | null });

export interface ListProductsOptions {
  query?: string;
  status?: 'active' | 'draft' | 'archived';
  limit?: number;
  cursor?: string | null;
}

export interface AttachOptions {
  asPrimary?: boolean;
  position?: number;
}

export interface MediaUploadInput {
  /** GCS-hosted URL of the image to upload. */
  fileUrl: string;
  altText?: string;
  position?: number;
}
